<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        scrollable
        width="500"
    >

      <v-card>

        <v-card-title>
          Filtrer par
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">

          <v-autocomplete multiple
                          v-model="form.campaigns"
                          prepend-inner-icon="mdi-filter-outline"
                          chips
                          deletable-chips
                          small-chips
                          item-text="name.fr"
                          item-value="id"
                          :items="campaigns"
                          outlined
                          dense
                          label="Campagnes"/>


          <v-dialog
              ref="dialog"
              v-model="modal"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field outlined
                            prepend-inner-icon="mdi-filter-outline"
                            dense
                            hide-details
                            v-model="dateRangeText"
                            append-icon="mdi-calendar-outline"
                            clearable
                            label="Date debut - fin"
                            placeholder="Date debut - fin"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="dates = []"
              ></v-text-field>
            </template>

            <v-date-picker v-model="dates" range scrollable>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="modal = false">
                Fermer
              </v-btn>
              <v-btn :disabled="dates.length < 2"
                     color="primary"
                     text
                     @click="modal = false">
                ok
              </v-btn>
            </v-date-picker>
          </v-dialog>

        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-btn :disabled="(dates.length < 2 )  && (!status) && (!service_id)"
                 block
                 color="primary"
                 depressed type="submit"
                 @click="handleFilter">
            <v-icon left>mdi-magnify</v-icon>
            Rechercher
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </div>
</template>

<script>

export default {
  props: ['campaigns'],
  data() {
    return {
      modal: false,
      dialog: false,
      status: null,
      service_id: null,
      dates: [],
      form: {
        campaigns: []
      },
    }
  },
  methods: {
    open() {
      this.dates = []
      this.status = null
      this.service_id = null
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    handleFilter() {
      let data = {
        dates: this.dates,
        status: this.status,
        service_id: this.service_id,
      }
      this.$emit('filter', data)
      this.close()
    },
  },
  computed: {
    dateRangeText: {
      get() {
        return this.dates.join(' ~ ')
      },
      set(dates) {
        return dates
      }
    }
  },
}
</script>

